__turbopack_context__.v({
  "appBar": "_7rgjbW_appBar",
});
